import { render, staticRenderFns } from "./DistributionListView.vue?vue&type=template&id=f8b7a1d0&"
import script from "./DistributionListView.vue?vue&type=script&lang=js&"
export * from "./DistributionListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports